'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require('./Observer');

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * model class of streets
 */

var SchoolYearParamsModel = function (_Observer) {
    _inherits(SchoolYearParamsModel, _Observer);

    /**
     * Beginn des Schuljahres
     * @type {date}
     */
    function SchoolYearParamsModel(observers, id, request) {
        _classCallCheck(this, SchoolYearParamsModel);

        var _this = _possibleConstructorReturn(this, (SchoolYearParamsModel.__proto__ || Object.getPrototypeOf(SchoolYearParamsModel)).call(this, observers, id, request));

        _this.Description = '';
        _this.SchoolYearBegin = '';
        _this.SchoolYearEnd = '';
        return _this;
    }
    /**
     * Ende des Schuljahres
     * @type {date}
     */

    /**
     * Beschreibung
     * @type {string}
     */


    _createClass(SchoolYearParamsModel, [{
        key: 'GetSchoolYearParams',
        value: function GetSchoolYearParams(schoolId, ticketId, contractStart) {
            var me = this;

            var rqString = "/ContractsSchoolYearParams?schoolId=" + schoolId + "&ticketId=" + ticketId;
            if (contractStart !== null && contractStart !== undefined) {
                rqString += "&contractStart=" + contractStart;
            }

            this.request.setRequest(rqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.Description = result.Data.Description;
                        me.SchoolYearBegin = result.Data.SchoolYearBegin;
                        me.SchoolYearEnd = result.Data.SchoolYearEnd;
                    }
                }
                var id = me.Id ? me.Id : "SchoolYearParams";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return SchoolYearParamsModel;
}(_Observer3.default);

exports.default = SchoolYearParamsModel;